module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/prologue#ucu7QS845MPh3AEZE9UYx79"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1#u34rqhbuyOWS8FdemGe5uwC"
    }
  }, [_vm._v("CHAPTER ONE: The Unreal Dream")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter2#uGinfQseYzclKBTKTMvBX99"
    }
  }, [_vm._v("CHAPTER TWO: Descent Into the Deep State")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter3#uMZ7nwtsf3lSfWD76L63at2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE: The Ultimate Horror")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4#uV3ROB4K34jBYzgZOVx6944",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR: The Knock on the Door")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5#upMc7SoLOswGeB7FmFS3W5H",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE: HANO: High Altitude No Opening")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6#uBtQ8hJsZFNn9zyZAqjLeuB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX: The Evidence Closes In")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter7#uQcRFYP2w9NrijRAu5deVf8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: Big Brother Was Listening")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Interlude#uYwNtfJOaEAbmB5Ds2weQNH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERLUDE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter8#uoqHWjQ6fZjIOXroetf6yv9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: The Cruelties of Fate")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue#ugzoQMYbtLQzmSoqirXxRNB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: Exoneration: The Long Wait")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Photos#uNaXUoIbKRPKd5QIjBKBGFE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHOTOS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AuthorsNote#uxHbrffvzcsRSO5rjOrOucG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Dedication#ubLBhKs8C3KiHRNovOafXhF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEDICATION")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0